import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { DivisionProvider } from "@/context/DivisionContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Calculator from "@/pages/Calculator";
import OpenBids from "@/pages/OpenBids";
import Projects from "@/pages/Projects";
import Operations from "@/pages/Operations";
import Analytics from "@/pages/Analytics";
import Admin from "@/pages/Admin";
import Users from "@/pages/Users";
import AccountsReceivable from "@/pages/AccountsReceivable";
import CompletedProjects from "@/pages/CompletedProjects";
import Contractors from "@/pages/Contractors";
import ContractorProfile from "@/pages/ContractorProfile";
import ProjectMap from "@/pages/ProjectMap";
import Profile from "@/pages/Profile";
import Sidebar from "@/components/Sidebar";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <DivisionProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Sidebar />
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/bidding" element={<Calculator />} />
                    <Route path="/open-bids" element={<OpenBids />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/operations/:projectId" element={<Operations />} />
                    <Route path="/accounts-receivable" element={<AccountsReceivable />} />
                    <Route path="/completed" element={<CompletedProjects />} />
                    <Route path="/contractors" element={<Contractors />} />
                    <Route path="/contractors/:contractorId" element={<ContractorProfile />} />
                    <Route path="/map" element={<ProjectMap />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route 
                      path="/admin" 
                      element={
                        <ProtectedRoute adminOnly>
                          <Admin />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/users" 
                      element={
                        <ProtectedRoute adminOnly>
                          <Users />
                        </ProtectedRoute>
                      } 
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />
          </Routes>
          </DivisionProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
